<template>
    <div>
        <div class="top flex items-center justify-between">
            <h1 class="mb-0">{{ heading }}</h1>
            <AppButton
                :url="`${urlBase}/create`"
                label="Create new"
            >
                <template v-slot:icon>
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
                </template>
            </AppButton>
        </div>
        <ul class="mainList list-reset">
            <draggable
                :list="categories"
                @change="orderChanged(categories)"
            >
                <CategoriesListItem
                    v-for="item in categories"
                    :key="item.id"
                    :item="item"
                    :url-base="urlBase"
                    @orderChanged="orderChanged"
                    @deleteItem="item => deleteDialog = item"
                />
            </draggable>
        </ul>
        <portal to="endOfPage">
            <DialogAction
                v-if="deleteDialog"
                heading="Delete category"
                text="Do you really want to delete this category?"
                accept-text="Delete"
                @accept="removeItem(deleteDialog)"
                @close="deleteDialog = null"
            >
                <template v-slot:topIcon>
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6"/></svg>
                </template>
            </DialogAction>

        </portal>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import CategoriesListItem from './CategoriesListItem.vue';
import AppButton from '../ui/AppButton.vue';
import DialogAction from '../dialog/DialogAction.vue';
import { get, update, remove } from '../../utils/apiHelper';

export default {
    components: {
        draggable,
        CategoriesListItem,
        AppButton,
        DialogAction,
    },
    props: {
        heading: {
            type: String,
            required: true,
        },
        apiBase: {
            type: String,
            required: true,
        },
        urlBase: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        categories: null,
        deleteDialog: null,
    }),
    async created() {
        this.getCategories();
    },
    methods: {
        async getCategories() {
            this.categories = await get(`/api/${this.apiBase}`);
        },
        async orderChanged(categories) {
            const newOrders = categories.map((category, index) => ({
                id: category.id,
                sort_order: index + 1,
            }));

            await update(`/api/${this.apiBase}/sort-order`, { newOrders });
        },
        async removeItem(item) {
            this.deleteDialog = null;
            await remove(`/api/${this.apiBase}/${item.id}`);
            this.getCategories();
        },
    },
};
</script>

<style lang="postcss" scoped>
.top {
    margin-bottom: 25px;
}
</style>
